<template>
  <header
    id="page-header"
    class="border-border flex flex-wrap items-center justify-between gap-3 bg-white p-6 sm:border-0 md:border-b"
  >
    <div class="flex grow flex-col gap-y-3">
      <h1 class="text-2xl font-bold whitespace-nowrap">
        <slot name="title" />
      </h1>
      <h2 v-if="$slots.subtitle" class="text-muted-foreground -mt-2! text-base font-normal">
        <slot name="subtitle" />
      </h2>
      <slot v-if="$slots.secondary" name="secondary" />
    </div>
    <div class="flex h-full flex-row justify-center gap-x-3">
      <slot name="actions" />
    </div>
  </header>
</template>
